<h1 mat-dialog-title>Confirm products {{ Error }}</h1>
<div mat-dialog-content class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row" [formGroup]="FormularioConfirmar">
    <mat-form-field class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
      <mat-label>Quantity</mat-label>
      <input matInput class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" type="number" formControlName="Quantity" />
    </mat-form-field>
    <mat-form-field class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
      <mat-label>PalletAmount</mat-label>
      <input matInput class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" [disabled]="true" formControlName="PalletAmount" />
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
      <mat-label>Select location</mat-label>
      <mat-select formControlName="location" [disabled]="true" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <mat-option *ngFor="let item of ArrayLocations" [value]="item.id">{{
          item.Location
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
      <mat-label>Notes</mat-label>
      <textarea matInput formControlName="Notes" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"></textarea>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <button
      mat-raised-button
      color="danger"
      (click)="onNoClick()"
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
    >
      Cancel
    </button>
    </div>
    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <button
      mat-raised-button
      color="primary"
      (click)="OnConfirmar()"
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
    >
      Confirm
    </button>
    </div>
  </div>
 
 
</div>
